import {usingJSON5} from '../json/usingJSON5';
import {asString} from './asString';

export const asString5 = usingJSON5(asString);
